
export class BasicCriteria {
businessUnitCode: string;
businessUnitCodeList: string[];
code: string;
createTime: number | null;
domain: string;
domainList: string[];
limit: number | null;
manageDeleted: boolean;
manageDeprecated: boolean;
minCreateOrUpdateTime: number | null;
minVersion: string;
offset: number | null;
pageIndex: number | null;
pageSize: number | null;
revisionNumber: number | null;
updateTime: number | null;
}

